<template>
    <div class="projects-overview-filter-bar">
        <div class="projects-overview-filter-bar__inner">
            <div class="projects-overview-filter-bar__actions">
                <div class="projects-overview-filter-bar__action">
                    <label for="sortBy">Projekte sortieren nach:</label>
                    <select id="sortBy" :value="filters.sortBy" @input="setSortBy">
                        <option
                            v-for="(option, key) in sortOptions"
                            :value="option.key"
                            :key="key"
                        >
                            {{ option.label }}
                        </option>
                    </select>
                </div>
                <div class="projects-overview-filter-bar__action">
                    <input type="checkbox" id="archived" :value="filters.archived" @input="toggleArchived">
                    <label for="archived">
                        Archiviert
                    </label>
                </div>
                <div class="projects-overview-filter-bar__action">
                    <a href="#projects-map-canvas">
                        <span class="mdi mdi-earth"></span> Projekte auf der Landkarte ansehen
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SORT_BY_DATE, SORT_BY_HEARTS } from '@/types'

export default {
    name: 'ProjectsOverviewFilterBar',

    props: {
        filters: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            sortOptions: {
                SORT_BY_DATE: {
                    label: 'Einstelldatum',
                    key: SORT_BY_DATE
                },
                SORT_BY_HEARTS: {
                    label: 'Anzahl der Herzen',
                    key: SORT_BY_HEARTS
                }
            }
        }
    },

    methods: {
        setSortBy () {
            // emit fresh object without store bindings
            this.$emit('changed', {
                ...this.filters,
                sortBy: event.target.value
            })
        },

        toggleArchived () {
            // emit fresh object without store bindings
            this.$emit('changed', {
                ...this.filters,
                archived: !this.filters.archived
            })
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectsOverviewFilterBar.vue